import React, {useState } from "react";
import RadioButtons from "./RadioButtons";
import { Formik } from "formik";

const Basic = () => {
  // use for ids
  let i = 0;

  // array object for radio buttons
  let radio_buttons_array = [
	 { value: 1,
	   label:"a very very very long dog is not very  friendly to the radio buttons",
	   selected: false},
    { value: 2, label: "dog", selected: false },
    { value: 3, label: "cat", selected: false },
    { value: 4, label: "fly", selected: false },
    { value: 5, label: "duck", selected: false },
    { value: 6, label: "pig", selected: false }
  ];
  // init answer3 to empty
  // this will store the radio buttons' selected value
  const [answer3, setAnswer3] = useState("");


  // init answer4 with empty array,
  // this keep all the updated checkbox objects
  const [answer4] = useState([]);

  // this two replace by formik
  // function focusOn(event) {

  // }

  // function focusOff(event) {

  // }

  return (
    <div>
      <hr />
      <Formik
        initialValues={{
          radiobuttons1: ""
        }}
        // all validation rules go in here
        validate={(values) => {
          const errors = {};

          // radio buttons value needed
          if (values.radiobuttons1 === "") {

            errors.radiobuttons1 = "Please select one";
          }

          // return errors object with all error strings
          return errors;
        }}
        onSubmit={(values, { setSubmitting }) => {
          setTimeout(() => {
            // ajax submit functions goes here
            // now just do an alert
            alert(JSON.stringify(values, null, 2));
            setSubmitting(false);
          }, 1);
        }}
        validateOnBlur={true}
        validateOnChange={false}
      >
        {({
          values /* all data need to run the valdation*/,
          errors /* all error strings */,
          touched /* all field touch event  */,
          handleChange /* value change event handler */,
          handleBlur /* onBlur event handler */,
          handleSubmit /* for submit button */,
          validateForm
          /* and other goodies */
        }) => (
          <form onSubmit={handleSubmit}>
            {/* email input box with error message */}
           
            <br />
           
            <br />
            <RadioButtons
              id={"radio_buttons_" + i++}
              label={"Radio Buttons"}
              name="radiobuttons1"
              // init data array setup radio buttons
              data={radio_buttons_array}
              isRequired={true}
              //layoutVertical={false}
              layoutVertical={true}
              // formik test value of selected item, will filter out "DEFAULT"
              value={(e) => {
                values.radiobuttons1 = e;
                setAnswer3(e);
              }}
              // update both value (values and answer3) on change,
              onChange={(e) => {
                handleChange(e);
                setAnswer3(e);
              }}
              // update both value (values and answer3) on change, force do validate field
              onBlur={(e) => {
                handleBlur(e);
                setAnswer3(e);
                validateForm();
              }}
              // if touched and has error
              hasError={touched.radiobuttons1 && errors.radiobuttons1}
              // get error message from errors
              errorMessage={errors.radiobuttons1}
              // on forcus, change touched to true
              onFocus={(e) => {
                touched.radiobuttons1 = e;
              }}
            />
            <br />
            <span>
              you picked {answer3} - {values.radiobuttons1}.
            </span>
            <br />
            <hr />
            <span>
              you picked:
              {answer4.map((item, index) => (
                <div key={index}>
                  <span>id:{item.id}, </span>
                  <span>label:{item.label}, </span>
                  <span>
                    selected:{" "}
                    <span style={{ color: "red" }}>
                      {item.selected.toString()}.
                    </span>
                  </span>
                </div>
              ))}
            </span>
            <br />
            <hr />
           
            <hr />

            <br />
           
            <hr />
            {/* submit button, enable/disable by Formik 
                using Button component,
                need passing button label, style, and id
                isDisabled control by formik
            */}
            <br />
            -----------------------
            <br />
            radio buttons: {JSON.stringify(values.radiobuttons1)} - touched:
            {JSON.stringify(touched.radiobuttons1)} - error:
            {errors.radiobuttons1}.
            <br />
            <br />
            -----------------------
          </form>
        )}
      </Formik>
      <span>radio buttons selected : {answer3}</span>
      <br />
      -----------------------
    </div>
  );
};

export default Basic;
